import DistinctiveAnswers from './DistinctiveAnswers';

export default DistinctiveAnswers;
